import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'

export type WidgetInputMenuButtonItem = {
	id: string
	label: ReactNode
	onSelect: () => void
	disabled?: boolean
}

export interface WidgetInputMenuButtonProps {
	label: ReactNode
	items: ReadonlyArray<WidgetInputMenuButtonItem>
	disabled?: boolean
}

export function WidgetInputMenuButton({ label, items, disabled = false }: WidgetInputMenuButtonProps) {
	return (
		<Popover className="relative">
			{({ close }) => (
				<>
					<PopoverButton
						className={ctl(`
							text-xs text-grey-600 bg-white ring-1 ring-grey-200 rounded shadow-sm
							px-2 py-0.5
							hover:bg-grey-50 hover:ring-grey-300
							${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
						`)}
						disabled={disabled}
					>
						{label}
					</PopoverButton>

					<PopoverPanel
						anchor="bottom start"
						className="z-50 bg-white [--anchor-gap:4px] ring-1 ring-grey-100 shadow-md rounded text-sm text-grey-600"
					>
						<ul className="p-1">
							{items.map((item) => (
								<li key={item.id}>
									<button
										className={ctl(`
											w-full text-left block
											hover:bg-purple-100 hover:text-purple-700
											px-2 py-1 rounded text-xs
											${item.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
										`)}
										onClick={() => {
											item.onSelect()
											close()
										}}
										disabled={item.disabled}
									>
										{item.label}
									</button>
								</li>
							))}
						</ul>
					</PopoverPanel>
				</>
			)}
		</Popover>
	)
}
